import {applyMiddleware, legacy_createStore} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

// Create and export Redux store using root reducer (combined reducer) and redux thunk
export default legacy_createStore(rootReducer, applyMiddleware(thunk));